import { z } from 'zod';

export const $CandidatePaymentPeriod = z.object({
  id: z.number(),
  name: z.string(),
});
